// gatsby-browser.js
// require("prismjs/themes/prism-coy.css");
require("prismjs/themes/prism-solarizedlight.css");
